import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { BookingStatus } from '../../../../../redux/booking/bookingSlice';

const BookingClient: React.FC<{ clientName: string; bookingStatus: BookingStatus }> = ({
  clientName,
  bookingStatus,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Typography
      variant="bodyBold"
      sx={{
        paddingLeft: '10px',
        paddingRight: '10px',
        fontSize: isSmallScreen ? '14px' : '18px',
        fontWeight: 700,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: isSmallScreen ? '120px' : '200px',
        background:
          bookingStatus === BookingStatus.CANCELED
            ? 'linear-gradient(180deg, #85B5C9 0%, #6CA3AC 100%)'
            : 'none',
        color:
          bookingStatus === BookingStatus.CANCELED ? 'transparent' : theme.palette.primary.main,
        WebkitBackgroundClip: bookingStatus === BookingStatus.CANCELED ? 'text' : 'unset',
        backgroundClip: bookingStatus === BookingStatus.CANCELED ? 'text' : 'unset',
      }}
    >
      {clientName}
    </Typography>
  );
};

export default BookingClient;
